import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Files } from 'components/misc'
import { Title, Span } from 'components/layout'

export default class TasksEvidence extends PureComponent {
  static propTypes = {
    observations: PropTypes.string,
    fileUrls: PropTypes.array
  }

  static defaultProps = {
    fileUrls: []
  }

  render() {
    const { observations, fileUrls } = this.props

    return (
      <div>
        <Title h2 intlKey="tasks.observations">
          Observations
        </Title>
        {observations}
        <div className="base-margin">
          <Files urls={fileUrls} />
        </div>
        {!observations &&
        fileUrls.length === 0 && <Span intlKey="label.no_data">No data</Span>}
      </div>
    )
  }
}
